module.exports = __webpack_public_path__ + "static/tiktok_icon-402be46cc47823f0c70a580389ab26d8.png";